module.exports = __webpack_public_path__ + "static/media/mshtml_32547.28bfbd8a.ico";